import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { StaticImage } from 'gatsby-plugin-image';
import { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

export const ARMATURE_WORKS_TITLE = 'Armature Works';

export const Head = () => {
  return (
    <ComponentsHead
      title="Armature Works by Boat | Private Charters in Tampa Bay"
      description="Sail into Armature Works in style. Book a private charter and dock near Tampa’s top food hall for dining, drinks, and skyline views."
      keywords="Armature Works, Food Hall, Dining by Boat, Tampa Destinations"
    />
  );
};

const Page: FC = () => {
  return (
    <AddOnsTemplate
      title="Private Boat Charter to Armature Works | Foodie Destination on the Water"
      subtitle={ARMATURE_WORKS_TITLE}
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${ARMATURE_WORKS_TITLE} header`}
              src="../../images/destinations/armature-works/0.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${ARMATURE_WORKS_TITLE} slide 1`}
              src="../../images/destinations/armature-works/1.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
    </AddOnsTemplate>
  );
};

export default Page;
